import React from 'react';
import styles from "./ShippingCarrierPerformance.module.scss";
import DynamicTableFilters from '../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { shippingCarrierTableData } from '../../../../../views/AdminPortal/dummyData';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';

const ShippingCarrierPerformance = () => {
    const navigate = useNavigate();

    const options = [
        { label: "View performance", action: () => navigate('/ordermanagement/orderfulfillment/shippingdetail') },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Carrier",
            selector: (row) => row.carrier,
            center: "true",
            width: "150px",
        },
        {
            name: "On-Time Delivery (%)",
            selector: (row) => row.deliveryPercentage,
            center: "true",
            minWidth: "200px",
        },
        {
            name: "Average Transit Time (days)",
            selector: (row) => row.avgTime,
            center: "true",
            minWidth: "240px",
        },
        {
            name: "Damaged Packages (%)",
            selector: (row) => row.damagedPercentage,
            center: "true",
            minWidth: "220px",
        },
        {
            name: <span style={{ color: "#FF0004" }}>Lost Packages (%)</span>,
            selector: (row) => row.lostPercentage,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Action",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters componentName={"Shipping Carrier Performance"} onApply={handleApply} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={shippingCarrierTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default ShippingCarrierPerformance;